import type { TFunction } from "i18next";
import { z } from "zod";

export const MAX_RESOLVE_DEFICIENCY_EXPLANATION_LENGTH = 1000;

export const resolveDeficiencySchema = (t: TFunction) =>
  z.object({
    explanation: z
      .string()
      .trim()
      .min(
        1,
        t("form-validation.mandatory", {
          label: t("deficiencies.resolve-drawer.fields.explanation"),
        }),
      )
      .max(
        MAX_RESOLVE_DEFICIENCY_EXPLANATION_LENGTH,
        t("form-validation.max-length", {
          label: t("deficiencies.resolve-drawer.fields.explanation"),
          max: MAX_RESOLVE_DEFICIENCY_EXPLANATION_LENGTH,
        }),
      ),
  });

export type ResolveDeficiencyFormData = z.infer<ReturnType<typeof resolveDeficiencySchema>>;
